import { gql } from "@apollo/client";

export const GQL_TAX_ACCOUNT_SEDI_AUTOCOMPLETE = gql`
   query taxAccountSediAutocomplete($input: SediAutoCompleteInput!) {
      taxAccountSediAutocomplete(input: $input)
   }
`;

export const GQL_TAX_ACCOUNTS_BY_TAX_PROVIDER = gql`
   query taxAccountsByTaxProvider($tax_provider_id: ID!) {
      taxAccountsByTaxProvider(tax_provider_id: $tax_provider_id) {
         id
         code
         address
         place
         zip_code
         client {
            id
            company_name
         }
         province {
            id
            description
         }
         comune {
            id
            description
         }
         building_codice
      }
   }
`;

export const GQL_TAX_ACCOUNT_CADASTAL_DATAS = gql`
   query taxAccountCadastalDatas($tax_account_id: ID!) {
      taxAccountCadastalDatas(tax_account_id: $tax_account_id) {
         id
         ubicazione_sezione
         foglio
         mappale
         subalterno
         rendita_catastale
         di_proprieta
         percentuale_proprieta
         cadastal_data_category {
            id
            code
            description
         }
         attachments
         mq_catastali
         mq_dichiarati
         mq_calcolati
      }
   }
`;

export const GQL_TAX_ACCOUNT_CADASTAL_DATAS_ATTACHMENT_DOWNLOAD = gql`
   query taxAccountCadastalDataDownloadAttachment(
      $id: ID!
      $attachment_id: String!
   ) {
      taxAccountCadastalDataDownloadAttachment(
         id: $id
         attachment_id: $attachment_id
      ) {
         name
         url
      }
   }
`;

export const GQL_WASTE_EDITOR_PUBLIC_FACILITIES_AND_OPTIONS = gql`
   query wasteEditorOptions($id: ID!) {
      unitMeasureTypes
      wasteBinTypes
      taxAccountPublicFacilities(id: $id) {
         id
         bin_type
         bin_capacity
         um
         cerCode {
            id
            code
            description
         }
         frequency
         exposure_frequency
         bin_number
      }
   }
`;

export const GQL_WASTE_EDITOR_PRIVATE_FACILITIES_AND_OPTIONS = gql`
   query wasteEditorOptions($tax_account_id: ID!, $private_tax_provider_id: ID!) {
      unitMeasureTypes
      wasteBinTypes
      privateTaxProviderPrivateFacilities(
         tax_account_id: $tax_account_id
         private_tax_provider_id: $private_tax_provider_id
      ) {
         id
         bin_type
         bin_capacity
         um
         cerCode {
            id
            code
            description
         }
         frequency
         exposure_frequency
         bin_number
      }
   }
`;

export const GQL_TAX_ACCOUNT = gql`
   query taxAccount($id: ID!) {
      taxAccount(id: $id) {
         id
         code
         tax_provider {
            id
            company_name
         }
         client {
            id
            company_name
         }
         province {
            id
            code
            description
         }
         comune {
            id
            code
            description
         }
         address
         place
         zip_code

         latitude
         longitude
         building_codice
         building_competenza
         building_tipologia
         building_insegna

         building_photo_name

         #url completo
         building_photo_name_url

         static_map_image

         #url completo
         static_map_image_url

         tariffa_corrispettiva
         tax_provider_code
         open_date

         private_tax_providers {
            privateTaxProvider {
               id
               company_name
               pec
            }

            request_info_at
            request_info_recipient
            request_year
         }

         charityItems {
            charity {
               id
               company_name
               email
               pec
            }
            request_info_at
            request_info_recipient
            request_year
         }

         closed
         closing_date
         closing_note

         ateco {
            id
            code
            description
         }

         taxProviderChange {
            id
            currentTaxProvider {
               id
               company_name
            }
            newTaxProvider {
               id
               company_name
            }
            user {
               id
               full_name
            }
            created_at
         }

         referent {
            id
            last_name
            first_name
            email
            phone
            created_at
            updated_at
         }
      }
   }
`;

export const GQL_TAX_ACCOUNTS_ALL = gql`
   query taxAccountsAll($input: TaxAccountsAllFilterInput!) {
      taxAccountsAll(input: $input) {
         data {
            id
            code
            address
            place
            zip_code
            client {
               id
               company_name
            }
            comune {
               id
               code
               description
               province {
                  id
                  code
                  description
                  regione {
                     id
                     name
                  }
               }
            }
         }
         paginatorInfo {
            current_page
            per_page
            total
            last_page
         }
      }
   }
`;

export const GQL_TAX_ACCOUNTS_EXPORT_ALL = gql`
   query exportTaxAccountsAll($input: TaxAccountsAllFilterInput!) {
      exportTaxAccountsAll(input: $input) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_TAX_ACCOUNT_TARI_DOSSIER_DETAIL = gql`
   query taxAccountTariDossierDetail($tax_account_id: ID!, $start_date: Date!) {
      tariByTaxAccountFromDate(
         tax_account_id: $tax_account_id
         start_date: $start_date
      ) {
         id
         tax_period_start
         tax_period_end
         number
      }
      dossiersFromTaxAccount(tax_account_id: $tax_account_id) {
         id
         name
         lastStatus {
            status
         }
         dossierBill {
            bill {
               id
            }
         }
         category {
            id
            name
         }
      }
   }
`;

export const GQL_TAX_ACCOUNT_WASTE_ANNUAL_ESTIMATION = gql`
   query taxAccountWasteAnnualEstimation($input: WasteAnnualEstimationInput!) {
      taxAccountWasteAnnualEstimation(input: $input) {
         public {
            cer_code {
               id
               code
               description
            }
            annual_estimated_quantity
            unit_measure
         }
         private {
            cer_code {
               id
               code
               description
            }
            annual_estimated_quantity
            unit_measure
         }
      }
   }
`;
